import {
  useAuth0 as _useAuth0,
  createAuth0 as _createAuth0,
  Auth0Plugin,
  type Auth0VueClient,
  type Auth0VueClientOptions,
  type Auth0PluginOptions
} from '@auth0/auth0-vue'
import { createMockAuth0, useMockAuth0 } from '../mocks/auth0-mock'

export function useAuth0(): Auth0VueClient {
  return window.__auth0Mock ? (useMockAuth0() as unknown as Auth0VueClient) : _useAuth0()
}

export function createAuth0(
  clientOptions: Auth0VueClientOptions,
  pluginOptions?: Auth0PluginOptions
): Auth0Plugin {
  return window.__auth0Mock
    ? (createMockAuth0() as unknown as Auth0Plugin)
    : _createAuth0(clientOptions, pluginOptions)
}
